<app-alerts />

<app-warehouse-restock-form
  (submitSuccessEvent)="handleSubmitSuccessEvent($event)"
  [fileUploadVisibility]="fileUploadVisibility()" />
